import { library,dom } from '@fortawesome/fontawesome-svg-core';

import {faFacebook,faLinkedin,faInstagram} from '@fortawesome/free-brands-svg-icons';
// import {} from '@fortawesome/pro-solid-svg-icons';
// import {} from '@fortawesome/pro-regular-svg-icons';
// import {} from '@fortawesome/pro-light-svg-icons';
// import {} from '@fortawesome/pro-thin-svg-icons';
// import {} from '@fortawesome/pro-duotone-svg-icons';
import {faPlus,faHeart} from '@fortawesome/sharp-solid-svg-icons';
library.add(faFacebook,faLinkedin,faPlus,faInstagram,faHeart);

dom.watch();
